import { type Country, type UserChiliPayFullUser, type UserRequirementState } from '@capsicum/common';
import { useGetRequirementStateByIdentifierQuery } from '@capsicum/features/regulations/shared';
import { useMe } from '@capsicum/socios-core';

import {
	type DocumentType,
	type FieldType,
	ORDER_FIELD_MAPPINGS,
	type OrderFieldKey,
	USER_PROVIDED_VALUES_PREFIX
} from '../models';

export const useOrderFields = () => {
	const { me } = useMe();
	const { data: requirementResult } = useGetRequirementStateByIdentifierQuery({
		requirementIdentifier: 'proof_of_id'
	});

	const getNestedValue = (
		obj: null | undefined | UserChiliPayFullUser | UserRequirementState,
		path: string
	): string => {
		return (
			(path.split('.').reduce((current: unknown, key: string) => {
				return current && typeof current === 'object' && key in current
					? (current as Record<string, unknown>)[key]
					: undefined;
			}, obj) as string) || ''
		);
	};

	const getFieldValue = (fieldCategory: string): string => {
		if (!(fieldCategory in ORDER_FIELD_MAPPINGS)) return '';

		const path = ORDER_FIELD_MAPPINGS[fieldCategory as OrderFieldKey];

		const result =
			path.startsWith(USER_PROVIDED_VALUES_PREFIX) && requirementResult
				? getNestedValue(requirementResult, path)
				: getNestedValue(me, path);

		return result;
	};

	const getFieldValueWithFallback = (
		field: FieldType,
		formatter?: (value: Country | DocumentType | string) => Country | DocumentType | string
	) => {
		const value = field.value === null ? getFieldValue(field.fieldCategory) : (field.value as string) || '';

		return formatter ? formatter(value) : value;
	};

	return {
		getFieldValueWithFallback
	};
};
